<template>
  <v-app :class="{ 'cloudtask': isCloudTask }">
    <vue-snotify></vue-snotify>
    <router-view></router-view>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      isCloudTask: state => state.auth.isCloudTask,
      isLoggedIn: state => state.auth.isLoggedIn
    }),
    apiKey () {
      if (process.env.VUE_APP_NODE_ENV === 'development' || process.env.VUE_APP_NODE_ENV === 'test') {
        return '38380609291157cb2303744e38da7a34'
      }

      return '330420cf382546dd82c3b8516b3ca72e'
    }
  },
  created () {
    const configChat = {
      apiKey: this.apiKey,
      hideToggleButton: true
    }
    window.keybe.webchatConversationsUiLoad(configChat)
  },
  watch: {
    isLoggedIn (value) {
      if (value) {
        this.$router.push('/')
      } else {
        this.$router.push('/auth')
      }
    }
  }
}
</script>
